import { ActivityComponent } from "@/features/esoPerson/activity/ActivityComponent"

export const ActivityPage = () => {
  return <ActivityComponent />
}
